import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import Environment from './app/environment';
import AppRouter from './app/routes';
import { ThemeProvider } from 'styled-components';
import { AppProvider } from './app/contexts/App';
import { App as AntdApp } from 'antd';
import './index.css';
// @ts-ignore
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
console.log('Version:', '1.0.1');
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: Environment.userPoolId,
            userPoolClientId: Environment.userPoolClientId,
        },
    },
});

mapboxgl.accessToken = Environment.mapboxKey;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    // @ts-ignore - styled-components type compatibility with React 18
    <ThemeProvider theme={{}}>
        <AntdApp>
            <AppProvider>
                <AppRouter />
            </AppProvider>
        </AntdApp>
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
